import SearchGroup from './containers/search_group/SearchGroup';
import { useState } from 'react';
import TablePage from './containers/table_page/TablePage';
import ModalML from '@/components/modal_ml/ModalML';
import './index.less';
import AddRule from './containers/add_rule/AddRule';
import React, { useEffect, useCallback } from 'react';
import { useDispatch } from 'dva';
import { message } from 'antd';

const RuleEngine = () => {
  const dispatch = useDispatch();
  const [searchVal, setSearchVal] = useState({});
  const [addVisble, setAddVisble] = useState(false);
  const [parents, setParents] = useState({});
  const [handleStatus, setHandleStatus] = useState('add');
  const handleSearch = (Val) => {
    setSearchVal({ ...Val });
  };

  const handleOk = () => {};
  const handleCancel = () => {
    setAddVisble(false);
  };
  //添加编辑规则
  const addRuleChange = (record, status) => {
    setAddVisble(true);
    if (record) {
      setParents(record);
      setHandleStatus(status);
    } else {
      setParents({});
      setHandleStatus(status);
    }
  };

  // 发起请求
  const fetchData = useCallback(() => {
    dispatch({
      type: 'ruleManage/getRuleManaList',
      payload: {
        values: {
          ...searchVal,
        },
      },
      callback: (s) => {
        const { code, message: msg } = s || {};
        if (code && JSON.stringify(code) !== '0') {
          message.warning(msg);
          return;
        }
      },
    });
  }, [dispatch, searchVal]);
  useEffect(() => {
    fetchData();
  }, [fetchData]);
  return (
    <div className="re">
      <div className="contain">
        <SearchGroup
          handleSearch={(Val) => handleSearch(Val)}
          addRuleChange={addRuleChange}
        />
        <TablePage
          params={searchVal}
          addRuleChange={addRuleChange}
          fetchData={fetchData}
        />
      </div>
      <ModalML
        title=""
        visible={addVisble}
        handleOk={handleOk}
        handleCancel={handleCancel}
      >
        <AddRule
          handleOk={handleOk}
          handleCancel={handleCancel}
          fetchData={fetchData}
          parents={parents}
          handleStatus={handleStatus}
        />
      </ModalML>
    </div>
  );
};

export default RuleEngine;
